'use strict';

import { CommandRegistry } from './ajaxWrapNew.js';
import { ActionSets } from './ActionSets.js';
import { urlSafe } from './urlTools.js';


const chatlistCommands = {
    removeChatSelector: (selector) => {
        $(selector).remove();
        resetChatLibraryExists();
    },

};
CommandRegistry.registerCommands(chatlistCommands);

const chatlistActions = {
    'cht-new2tab': (data) => {
        data.action = 'cht-new2';
        data.addData.openedItemId = $('.select2chattype[name="library"]').val();
        return data;
    },
    'cht-tab': (data) => {
        data.addData.url = $(data.el).attr('href');
        return data;
    },
    'cht-page': (data) => {
        data.addData = {
            ...(data.addData || {}),

            loadPage: $(data.el).data('page'),
            pageUrl: $(data.el).closest('.tx-tab-pages').data('url')
        };
        return data;
    },
    'cht-sort': (data) => {
        data.addData.newSort = $(data.el).data('sort') == 1 ? 0 : 1;
        data.addData.openedItemId = $('.select2chattype[name="library"]').val();

        // mainam visiem čatiem sortēšanas kārtību;
        $('.chat-sort').data('sort', data.addData.newSort)
            .attr('data-sort', data.addData.newSort);

        return data;
    },

    'cht-edit-title': async (data) => {
        data.addData.encrypted = 1;
        return data;
    }
}
ActionSets.registerSet('chatlistActions', chatlistActions);

var resetChatLibraryExists = function () {
    let anyExists = $('.tx-tab-items').find('.cht-it').length > 0;
    if (!anyExists) {
        urlSafe.reload();
    }
};


export function loadLibrary() {

}